import React, { ReactNode } from 'react';
import {
  FormInput,
  Label,
  SegmentedControl,
  SegmentedControlProps,
} from '@grubhubprod/gh-cookbook-react';
import { Control, Controller, ControllerRenderProps } from 'react-hook-form';

export interface CookbookSegmentedControlWrapperProps
  extends Omit<SegmentedControlProps, 'onChange' | 'value'> {
  name: string;
  defaultValue: SegmentedControlProps['value'];
  label: ReactNode;
  inputSize?: 'medium' | 'small' | 'large';
  control: Control;
  valueToFormStateTransformer?: (
    v: SegmentedControlProps['value']
  ) => Array<SegmentedControlProps['value']>;
  formStateToValueTransformer?: (
    v: Array<SegmentedControlProps['value']>
  ) => SegmentedControlProps['value'];
}

export const CookbookSegmentedControlWrapper = ({
  name,
  control,
  defaultValue,
  label,
  inputSize = 'medium',
  valueToFormStateTransformer,
  formStateToValueTransformer,
  ...segmentedControlProps
}: CookbookSegmentedControlWrapperProps): JSX.Element => {
  const renderSegmentedControl = ({
    onChange,
    value,
  }: Partial<ControllerRenderProps>) => {
    const customOnChange = (value: SegmentedControlProps['value']) => {
      const transformedValue = valueToFormStateTransformer
        ? valueToFormStateTransformer(value)
        : value;

      onChange(transformedValue);
    };

    const segmentedControlValue = formStateToValueTransformer
      ? formStateToValueTransformer(value)
      : value;

    return (
      <FormInput inputSize={inputSize}>
        <Label htmlFor={segmentedControlProps.id}>{label}</Label>
        <SegmentedControl
          {...segmentedControlProps}
          onChange={customOnChange}
          value={segmentedControlValue}
        />
      </FormInput>
    );
  };

  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={renderSegmentedControl}
    />
  );
};
